import logo from './logo.svg';
import './App.css';
// import {useMachine , useInterpret, useSelector} from '@xstate/react';
// import {sendParent, send, interpret, assign, spawn,createMachine} from 'xstate';
// import { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import {useEffect, useState} from 'react';
 
import {useAuth} from './useAuth';




function App() {
  const {getuser, ConvertTokenToUserid} = useAuth();
  const [getuserPoolId,setuserPoolId] = useState("us-east-1_wrA4I0ZmE");
  const [getuserPoolWebClientId,setuserPoolWebClientId] = useState("1inpko7ddl5mbfu4iabpl0p71s");
  const [getpoolDataResult,setpoolDataResult] = useState(null)
  var poolData = {
    "userPoolId": getuserPoolId, // Your user pool id here
    "userPoolWebClientId": getuserPoolWebClientId, // Your client id here
  };
  
  const [getusername,setusername] = useState("weqdweqdf")
  const [getpassword,setpassword] = useState("loioihoihiS@#1")
  const [getemail,setemail] = useState("qhlpwntsvznxkqtuoa@tcwlx.com")
  
  
  var signUpPayload = {
    "username" : getusername,
    "password" : getpassword,
    "attributes" : {
      'email': getemail
    }
  }



const [getsignInResult,setsignInResult] = useState(null)

const signInAWS = async () => {
  try{
    const outcome = await Auth.signIn(getusername,getpassword)
    setsignInResult(outcome)
  }catch(e){
    setsignInResult(e)
  }
  
}

const [getsignUpResult,setsignUpResult] = useState(null)

const signUpAWS = async () => {
  try{
    const outcome = await Auth.signUp(signUpPayload)
    setsignUpResult(outcome)
  }catch(e){
    setsignUpResult(e)
  }
}

const [getverifyCode,setverifyCode] = useState("870719")

const signUpConfirmAWS = async () => {
  const outcome = await Auth.confirmSignUp(getusername,getverifyCode)
  console.log(outcome)
}

const [getjwtToken,setjwtToken] = useState()

const jwtAWS = async () => {
  const session = await Auth.currentSession();
  const jwtToken = session.getAccessToken().getJwtToken();
  setjwtToken(jwtToken)
  // console.log(jwtToken)
}
const [getcurrentUserInfo,setcurrentUserInfo] = useState()


// const [getguiuser, setguiuser] = useState(getuser)
useEffect(()=>{},[getuser])

  return (
    <div className="App">
      <h1>Simplest Auth signup, verify email, signin, signout Flow. </h1>
      <button onClick={()=>{setpoolDataResult(Auth.configure(poolData))}}>Setup userPoolId and userPoolClientId</button>
      <div>Setup Pooldata Results: {JSON.stringify(getpoolDataResult)}</div>
      <div>
      <textarea name="setPoolid" onChange={(e) => {setuserPoolId(e.target.value)}} value={getuserPoolId}/>
      <textarea name="setPoolClient" onChange={(e) => {setuserPoolWebClientId(e.target.value)}} value={getuserPoolWebClientId}/>
      </div>
      
      <div>
        <div>
          <input type="text" onChange={(e) => {setusername(e.target.value)}} value={getusername}/>
          <input type="text" onChange={(e) => {setpassword(e.target.value)}} value={getpassword}/>
          <input type="text" onChange={(e) => {setemail(e.target.value)}} value={getemail}/>
        </div>
        <button onClick={() => {signUpAWS()}} > hi sign up</button>
        <button onClick={() => {signUpConfirmAWS()}}> verify email </button>
        <button onClick={() => {signInAWS()}}>sign in </button>
        <button onClick={() => {Auth.currentUserInfo().then((v)=>setcurrentUserInfo(v))}}>Auth.currentUserInfo()</button>      
        <button onClick={() => {jwtAWS()}}>Auth.currentSession().getAccessToken().getJwtToken()</button>
        <button onClick={() => {Auth.signOut()}}>Auth.signout</button>
      </div>
      <div>
      <input type="text" onChange={(e) => {setverifyCode(e.target.value)}} value={getverifyCode}/>
      </div>
      <fieldset>
        Sign In Results: 
        <textarea value={JSON.stringify(getsignInResult,null,"\t")}/>
      </fieldset>
      <fieldset>
        Sign Up Results:
        <textarea value={JSON.stringify(getsignUpResult,null,"\t")}/>
      </fieldset>
      <fieldset>
        Auth.currentUserInfo(): 
        <textarea value={JSON.stringify(getcurrentUserInfo,null,"\t")}/>
      </fieldset>
      <fieldset>
      This is your jwt token Auth.currentSession().getIdToken().getJwtToken(): 
        <textarea value={getjwtToken}/>
      </fieldset>
   
      <button onClick={()=>{console.log(ConvertTokenToUserid(getjwtToken))}}>ConvertTokenToUserId</button>
      <button onClick={()=>{console.log(getuser)}}>theuseridstate</button>
      <textarea value={JSON.stringify(getuser,null,"\t")}/>
    </div>
  );
}

export default App;
